import { Routes } from '@angular/router';
import { InternalLayoutComponent } from '../layouts';
import { AuthGuard } from '../../shared/auth/services';
import { FileLibraryComponent } from './pages/file-library';
import { SharedLayoutMainComponent } from '../shared/layouts/main';

export const filesRoutes: Routes = [
  {
    path: 'useraccount',
    component: InternalLayoutComponent,
    canActivate: [AuthGuard],
    data: { roles: [] },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'files',
        component: SharedLayoutMainComponent,
        children: [
          { path: '', component: FileLibraryComponent, title: 'Files' },
        ]
      },
    ]
  }
];
